!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = r(require("react"), require("prop-types"), require("@leafygreen-ui/emotion")) : "function" == typeof define && define.amd ? define(["react", "prop-types", "@leafygreen-ui/emotion"], r) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).Checkmark = e.Checkmark || {}, e.Checkmark.js = r(e.React, e.PropTypes, e["@leafygreen-ui/emotion"]));
}(this, function (e, r, t) {
  "use strict";

  function n(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }
  function l(e) {
    if (e && "object" == typeof e && "default" in e) return e;
    var r = Object.create(null);
    return e && Object.keys(e).forEach(function (t) {
      if ("default" !== t) {
        var n = Object.getOwnPropertyDescriptor(e, t);
        Object.defineProperty(r, t, n.get ? n : {
          enumerable: !0,
          get: function () {
            return e[t];
          }
        });
      }
    }), r.default = e, Object.freeze(r);
  }
  var a = l(e),
    i = n(r);
  function o(e, r, t) {
    return (r = function (e) {
      var r = function (e, r) {
        if ("object" != typeof e || null === e) return e;
        var t = e[Symbol.toPrimitive];
        if (void 0 !== t) {
          var n = t.call(e, r || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(e);
      }(e, "string");
      return "symbol" == typeof r ? r : String(r);
    }(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  function u() {
    return u = Object.assign ? Object.assign.bind() : function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];
        for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
      return e;
    }, u.apply(this, arguments);
  }
  function f(e, r) {
    if (null == e) return {};
    var t,
      n,
      l = function (e, r) {
        if (null == e) return {};
        var t,
          n,
          l = {},
          a = Object.keys(e);
        for (n = 0; n < a.length; n++) t = a[n], r.indexOf(t) >= 0 || (l[t] = e[t]);
        return l;
      }(e, r);
    if (Object.getOwnPropertySymbols) {
      var a = Object.getOwnPropertySymbols(e);
      for (n = 0; n < a.length; n++) t = a[n], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (l[t] = e[t]);
    }
    return l;
  }
  function c(e, r) {
    return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(r)
      }
    }));
  }
  var s,
    b,
    p = {
      small: 14,
      default: 16,
      large: 20,
      xlarge: 24
    };
  var d = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"],
    y = function (e) {
      var r,
        n = e.className,
        l = e.size,
        i = void 0 === l ? 16 : l,
        y = e.title,
        m = e["aria-label"],
        g = e["aria-labelledby"],
        v = e.fill,
        h = e.role,
        O = void 0 === h ? "img" : h,
        j = f(e, d),
        k = t.css(s || (s = c(["\n        color: ", ";\n      "])), v),
        w = t.css(b || (b = c(["\n        flex-shrink: 0;\n      "]))),
        C = function (e, r, t) {
          var n,
            l,
            a = t["aria-label"],
            i = t["aria-labelledby"],
            u = t.title;
          switch (e) {
            case "img":
              return a || i || u ? (o(n = {}, "aria-labelledby", i), o(n, "aria-label", a), o(n, "title", u), n) : {
                "aria-label": (l = r, "".concat(l.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon"))
              };
            case "presentation":
              return {
                "aria-hidden": !0,
                alt: ""
              };
          }
        }(O, "Checkmark", (o(r = {
          title: y
        }, "aria-label", m), o(r, "aria-labelledby", g), r));
      return a.createElement("svg", u({
        className: t.cx(o({}, k, null != v), w, n),
        height: "number" == typeof i ? i : p[i],
        width: "number" == typeof i ? i : p[i],
        role: O
      }, C, j, {
        viewBox: "0 0 16 16"
      }), a.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.30583 9.05037L11.7611 3.59509C12.1516 3.20457 12.7848 3.20457 13.1753 3.59509L13.8824 4.3022C14.273 4.69273 14.273 5.32589 13.8824 5.71642L6.81525 12.7836C6.38819 13.2106 5.68292 13.1646 5.31505 12.6856L2.26638 8.71605C1.92998 8.27804 2.01235 7.65025 2.45036 7.31385L3.04518 6.85702C3.59269 6.43652 4.37742 6.53949 4.79792 7.087L6.30583 9.05037Z",
        fill: "currentColor"
      }));
    };
  return y.displayName = "Checkmark", y.isGlyph = !0, y.propTypes = {
    fill: i.default.string,
    size: i.default.oneOfType([i.default.number, i.default.string]),
    className: i.default.string
  }, y;
});